module.exports = __webpack_public_path__ + "img/IMG_1039_L_Wood_MockedUp.309b31e6.jpg";